import React from "react";

export const OnboardingHeadingLabel = ({label}) => {
  return (
    <div className={"flex flex-row items-center"}>
      <div>{label}</div>
    </div>
  );
};
